import { QueryClient } from 'react-query'

import { JSONError, NetworkError, StatusError } from './libs/enhancedFetch'

const DEFAULT_MAX_RETRIES = 2

const retryPredicate = (failureCount, error) => {
  if (failureCount === DEFAULT_MAX_RETRIES) {
    return false
  }

  switch (error?.name) {
    case NetworkError.name:
    case JSONError.name: {
      return true
    }
    case StatusError.name: {
      // Do not retry if it was an error on our request
      // I.e. we did a BAD REQUEST and the server returned errors for
      // our request
      if (error.status === 400 && error.dataHasErrors) {
        return false
      }

      return true
    }
    default: {
      console.error('Unknown non-request error -- Programming error?', error)
      return false
    }
  }
}

const createQueryClient = () =>
  new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        useErrorBoundary: true,
        retry: retryPredicate,
      },
      mutations: {
        useErrorBoundary: true,
        retry: retryPredicate,
      },
    },
  })

export default createQueryClient
